import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=4ba2d19d&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=4ba2d19d&prod&lang=scss"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=4ba2d19d&prod&lang=scss&scoped=true"
import style2 from "./Contacts.vue?vue&type=style&index=2&id=4ba2d19d&prod&lang=scss"
import style3 from "./Contacts.vue?vue&type=style&index=3&id=4ba2d19d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2d19d",
  null
  
)

export default component.exports